/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');

var tmplCorpFinSecondaryNameFormView = require('../templates/CorpFinSecondaryNameFormView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplCorpFinSecondaryNameFormView,

  className: 'corp-fin-secondary-name-form-view row',

  ui: {
    secondaryNameType: '.secondary-name-type'
  },

  onBeforeShow: function() {
    var isExemption = this.model.get('record').recordCategoryId == 2;
    if (isExemption) {
      this.ui.secondaryNameType.hide();
    }
    var secondaryName = this.model.get('secondaryName') || {};

    Syphon.deserialize(this, secondaryName);
  },

  getFormData: function() {
    var formData = Syphon.serialize(this);
    formData.recordId = this.model.get('recordId');
    return formData;
  }
});
